import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { TemperatureLogService } from '../temperature-log.service';
import { HelperService } from '../../../services/utils/helper.service';
import { PrintService } from '../../export/print.service';
import { CancelEditableRow } from 'primeng/table';
import { ResourceManagerService } from '../../../services/resourceManager/resource-manager.service';
import { LOV_KEYS } from '../../../dataModels/lovs';
/**
 * View details about the temperature logs
 */
@Component({
  selector: 'app-view-temperature-log-details',
  templateUrl: './view-temperature-log-details.component.html',
  styleUrls: ['./view-temperature-log-details.component.scss'],
})
export class ViewTemperatureLogDetailsComponent implements OnInit {
  /**
   * form group
   */
  viewDetailFrm: UntypedFormGroup;

  /**
   * indicate if component is busy making api calls
   */
  isBusy;

  /**
   * message to display during api calls
   */
  busyMessage;

  /**
   * list of temperature log details
   */
  temperatureLogDetailList = [];

  /**
   * additional data for view
   */
  additionalDataForView = [];

  /**
   * row data
   */
  @Input() rowData = {
    comments: '',
    prevComments:'',
    dateActivation: '',
    lastLogDate: '',
    logMasterSeq: '',
    logPeriodFrom: '',
    logPeriodTo: '',
    outOfRange: '',
    rankByUnit: '',
    submitionDate: '',
    unitSeq: '',
    unitStatus: '',
    unitStyle: '',
    unitType: '',
    unitName: '',
    unitTypeDescr: '',
    unitStyleDescr: '',
    unitStatusDescr: '',
    covidVaccineStored: '',
  };

  /**
   * broadcast cancel event
   */
  @Output() cancelEvent = new EventEmitter();

  /**
   * constructor to inject dependency
   * @param temperatureLogService instance of temperatureLog Service
   * @param helperService instance of helperService
   * @param printService instance of printService
   * @param resourceManagerService instance of resourceManagerService
   */
  constructor(
    private temperatureLogService: TemperatureLogService,
    private helperService: HelperService,
    private printService: PrintService,
    private resourceManagerService: ResourceManagerService
  ) {}

  /**
   * initialize component
   */
  ngOnInit(): void {

    this.initFormControls();
    this.getTemperatureLogDetails();
  }

  /**
   * initialize form controls
   */
  initFormControls() {
    this.viewDetailFrm = new UntypedFormGroup({
      prevComments: new UntypedFormControl({ value: '', disabled: true }),
      comments: new UntypedFormControl({ value: '', disabled: true }),
    });
  }

  /**
   * get temperature log details
   */
  getTemperatureLogDetails() {
    this.isBusy = this.temperatureLogService.getTemperatureLogDetails(this.rowData.logMasterSeq).then((response) => {
      console.log(response);
      const firstComments = response[0].comments || '';
      this.viewDetailFrm.get('comments').setValue(firstComments);
      this.temperatureLogDetailList = this.formTemperatureLogDetailList(response);
      if (this.temperatureLogDetailList.length > 0) {
        this.setRowData();
      }
    });
  }

  /**
   * form the list to render the view
   * @param list list recieved from api call
   */
  formTemperatureLogDetailList(list) {
    const tempLogDetailList = [];
    for (const log of list) {
      tempLogDetailList.push({
        date: log.logDate,
        officeStatus: log.officeStatus,
        hour: log.logHours,
        minute: log.logMin,
        minTempInC: this.convertToC(log.logMinTemp),
        minTempInF: log.logMinTemp,
        maxTempInC: this.convertToC(log.logMaxTemp),
        maxTempInF: log.logMaxTemp,
        staffInitials: log.staffName,
        userName: log.username,
        prevComments: this.helperService.decodeJsonString(log.comments)
      });
    }
    let commentValue = '';
    if(tempLogDetailList[0].prevComments) {
      commentValue = tempLogDetailList[0].prevComments.trim();
      commentValue = commentValue.replace(/[^a-zA-Z0-9\s]/g, '');
    }
    this.viewDetailFrm.controls.prevComments.setValue(commentValue);
    return tempLogDetailList;
  }

  /**
   * set row data
   */
  setRowData() {
    console.log(this.rowData);
    // this.rowData.unitTypeDescr = this.resourceManagerService.getLovColumnProperties(
    //   LOV_KEYS.STORAGE_UNIT_TYPE,
    //   this.rowData.unitType,
    //   'descr'
    // );
    // this.rowData.unitStyleDescr = this.resourceManagerService.getLovColumnProperties(
    //   LOV_KEYS.STORAGE_UNIT_STYLE,
    //   this.rowData.unitStyle,
    //   'descr'
    // );
    // this.rowData.unitStatusDescr = this.resourceManagerService.getLovColumnProperties(
    //   LOV_KEYS.STORAGE_UNIT_STATUS,
    //   this.rowData.unitStatus,
    //   'descr'
    // );
  }

  /**
   * convert Farenheit to celsius
   * @param degInF degrees in farenheit
   */
  convertToC(degInF) {
    let degInC = '';
    if (!this.helperService.IsNullOrEmpty(degInF) && degInC !== '-') {
      const degInFNum = +degInF;
      if (!isNaN(degInFNum)) {
        degInC = ((degInFNum - 32) / 1.8).toFixed(2);
      }
    }
    return degInC;
  }

  /**
   * get css classes for temperature
   * @param tempLogRowData rowData
   */
  getCssClasses(tempLogRowData) {
    const outOfRange = this.temperatureLogService.checkIfTemperatureIsOutOfRange(
      this.rowData.unitTypeDescr,
      tempLogRowData.officeStatus,
      tempLogRowData.minTempInF,
      tempLogRowData.maxTempInF
    );
    return {
      'text-danger': outOfRange,
      'text-success': !outOfRange,
    };
  }

  /**
   * print the details
   */
  print() {
    this.printService.print(document.getElementById('viewTempLogDetail').innerHTML);
  }

  /**
   * cancel detail page
   */
  cancelDetail() {
    this.cancelEvent.emit();
  }
}
